import fetchTaxonomy from "../services/fetchTaxonomy";
import { updateTaxonomyData } from "../store/globalCatalogManagement.slice";
import * as Sentry from "@sentry/react";
import { waitForSessionTokens } from "./session";

export const fetchTaxonomyDetails = async (dispatch: any) => {
  try {
    // Wait for session tokens to be available (up to 3 seconds)
    const tokensAvailable = await waitForSessionTokens();
    
    if (!tokensAvailable) {
      console.warn("Cannot fetch taxonomy: Authentication tokens not available after waiting");
      return;
    }
    
    const taxonomy = await fetchTaxonomy.getTaxonomy();
    const taxonomyData = taxonomy?.data?.result?.data;
    dispatch(updateTaxonomyData(taxonomyData));
  } catch (error) {
    console.error("Error occured while fetching taxonomy details", error);
    Sentry.captureException(error);
  }
};
